<script>
  import { _ } from "../../services/i18n";
</script>

<section class="section-elements">
  <table class="table-elements">
    <tr>
      <td class="box-elements" id="r-box">
        <a href="#/tuto?/compositor/summary/price">
        <h5>{$_("tutorial_summary_price")}</h5>
        <div class="info-elements">
          <p>Saber más</p>
          <img
            id="user-elements"
            src="/icons/arrow-left-white.svg"
            alt="close"
          />
        </div>
        <img id="element-elements" src="/icons/tag.svg" alt="eye" />
        </a>
      </td>
      <td class="box-elements" id="y-box">
        <a href="#/tuto?/compositor/summary/delete">
        <h5>{$_("tutorial_summary_delete")}</h5>
        <div class="info-elements">
          <p>Saber más</p>
          <img
            id="user-elements"
            src="/icons/arrow-left-white.svg"
            alt="close"
          />
        </div>
        <img id="element-elements" src="/icons/trash-sim3d.svg" alt="search" />
      </a>
      </td>
    </tr>

    <tr>
      <td class="box-elements" id="g-box">
        <a href="#/tuto?/compositor/summary/save-fav">
        <h5>{$_("tutorial_summary_save")}</h5>
        <div class="info-elements">
          <p>Saber más</p>
          <img
            id="user-elements"
            src="/icons/arrow-left-white.svg"
            alt="close"
          />
        </div>
        <img id="element-elements" src="/icons/tag.svg" alt="favourite" />
      </a>
      </td>

      <td class="box-elements" id="d-box">
        <a href="#/tuto?/compositor/summary/scene">
        <h5>{$_("tutorial_summary_scene")}</h5>
        <div class="info-elements">
          <p>Saber más</p>
          <img
            id="user-elements"
            src="/icons/arrow-left-white.svg"
            alt="close"
          />
        </div>
        <img id="element-elements" src="/icons/camera.svg" alt="camera" />
      </a>
      </td>
    </tr>
    <tr>
      <td class="box-elements" id="b-box">
        <a href="#/tuto?/compositor/summary/cart">
        <h5>{$_("tutorial_summary_cart")}</h5>
        <div class="info-elements">
          <p>Saber más</p>
          <img
            id="user-elements"
            src="/icons/arrow-left-white.svg"
            alt="close"
          />
        </div>
        <img id="element-elements" src="/icons/carrito.svg" alt="pencil" />
      </a>
      </td>
    </tr>
  </table>
</section>
